import { createFileRoute } from '@tanstack/react-router';
import { TenantsPage } from '@/components/gestao-tenants';

export const Route = createFileRoute('/_app/configuracoes/tenants')({
  component: TenantsPage,
});
